import { RefObject } from 'react'

/**
 * Detects if node is outside viewport and shifts if so
 * should not have existing inline styles
 */
export const shiftSelf = (ref: RefObject<HTMLElement>) => {
  const windowWidth = global.innerWidth
  const node = ref.current
  if (!node) return

  if (node.style) node.removeAttribute('style')
  const rect = node.getBoundingClientRect()
  const { left: elLeft, width: elWidth } = rect
  const rightBorder = elWidth + elLeft
  if (rightBorder >= windowWidth) {
    node.style.position = 'absolute'
    node.style.right = '0'
  }
}
